import React, { useState } from 'react';
import { SalvButton, Size } from '@salvapp/ui-components';
import { faShieldPlus } from '@fortawesome/pro-solid-svg-icons';
import CreateManualAlertModal from './CreateManualAlertModal';

interface CreateManualAlertButtonProps {
  personId: string;
  transactionId?: string;
  personName?: string;
  transactionAmount?: string;
  onAlertCreated?: () => void;
  variant?: 'primary' | 'secondary';
  size?: Size;
  className?: string;
}

export const CreateManualAlertButton = ({
  personId,
  transactionId,
  personName,
  transactionAmount,
  onAlertCreated,
  variant = 'primary',
  size = Size.SMALL,
  className,
}: CreateManualAlertButtonProps) => {
  const [showModal, setShowModal] = useState(false);

  const handleSuccess = () => {
    if (onAlertCreated) {
      onAlertCreated();
    }
  };

  const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();

  return (
    <div
      onClick={stopPropagation}
      onMouseDown={stopPropagation}
      onMouseUp={stopPropagation}
      onKeyDown={stopPropagation}
      onKeyUp={stopPropagation}
      onFocus={stopPropagation}
    >
      <SalvButton
        variant={variant}
        size={size}
        onClick={() => setShowModal(true)}
        className={className}
        iconLeft={faShieldPlus}
        label='New manual alert'
      />

      <CreateManualAlertModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onSuccess={handleSuccess}
        personId={personId}
        transactionId={transactionId}
        personName={personName}
        transactionAmount={transactionAmount}
      />
    </div>
  );
};

export default CreateManualAlertButton;
